export const types = Object.freeze({
  fetchPartnerDetails: 'FETCH-PARTNER-DETAILS',
  savefirmKeyDetails: 'SAVE-FIRM-KEY-DETAILS',
  saveFirmAddress: 'SAVE-FIRM-ADDRESS',
  addEmplyoee: 'ADD-EMPLOYEE',
  deleteEmployee: 'DELETE-EMPLOYEE',
  saveOtherSoftawaresUsed: 'SAVE-OTHER-SOFTWARES-USED',
  saveInvoiceInformation: 'SAVE-INVOICE-INFORMATION',
});

export const initialState = {
  partnerId: null,
  lastModified: null,
  currentStep: 4,
  firmKeyDetails: {
    companyName: '',
    kvkNumber: null,
    noOfClients: 0,
    noOfEmployees: 0,
    standardCompanyClassification: null,
  },
  firmAddress: {
    countryTypeId: 1,
    countryId: 0,
    postalCode: '',
    houseNumber: '',
    streetName: '',
    city: '',
    email: '',
    phoneNumber: '',
  },
  employeeInformation: [],
  otherSoftwaresUsed: {
    administrationSoftwareId: '',
    payrollSoftwareId: '',
    taxationSoftwareId: '',
  },
  invoiceInformation: {
    accountNumber: '',
    invoiceEmail: '',
    bankName: '',
    bankAccountName: '',
  },
  partnerReviewDetails: {
    isPartnerTermsAccepted: false,
  },
};

export const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case types.fetchPartnerDetails: {
      const {
        firmKeyDetails,
        firmAddress,
        otherSoftwaresUsed,
        invoiceInformation,
        currentStep,
        partnerId,
        employeeInformation,
        partnerReviewDetails,
      } = action.payload;
      return {
        ...state,
        firmKeyDetails,
        partnerId,
        employeeInformation,
        currentStep,
        firmAddress,
        otherSoftwaresUsed,
        invoiceInformation,
        partnerReviewDetails,
      };
    }
    case types.savefirmKeyDetails:
      return { ...state, firmKeyDetails: action.payload };
    case types.saveFirmAddress:
      return { ...state, firmAddress: action.payload };
    case types.addEmplyoee:
      return { ...state, employeeInformation: action.payload };
    case types.deleteEmployee:
      return { ...state, employeeInformation: action.payload };
    case types.saveOtherSoftawaresUsed:
      return { ...state, otherSoftwaresUsed: action.payload };
    case types.saveInvoiceInformation: {
      const { lastModified, formValues } = action.payload;
      return { ...state, lastModified, invoiceInformation: formValues };
    }
    default:
      return state;
  }
};
